import React, { useEffect, useRef, useState } from "react";

const FloatingInput = ({
  name,
  type,
  id,
  value,
  placeholder,
  disabled = false,
  error,
  handleBlur,
  onChange,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  const isPasswordField = type === "password";
  const inputType = isPasswordField
    ? showPassword
      ? "text"
      : "password"
    : type;

  const handlePaste = (e) => {
    if (isPasswordField) {
      e.preventDefault();
      alert("Cannot paste password");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  // Autofill detection and focus if a password is autofilled
  useEffect(() => {
    const checkAutofill = () => {
      if (inputRef.current && inputRef.current.value) {
        inputRef.current.classList.add("filled");
      } else {
        inputRef.current.classList.remove("filled");
      }
    };

    setTimeout(checkAutofill, 100);
    inputRef.current.addEventListener("input", checkAutofill);

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("input", checkAutofill);
      }
    };
  }, []);

  return (
    <div className={`relative ${error ? "mb-4" : "mb-0"}`}>
      <input
        ref={inputRef}
        disabled={disabled}
        type={inputType}
        name={name}
        id={id}
        value={value} // Ensure the input value is controlled
        placeholder=" "
        autoComplete="on"
        required
        className={`w-full px-3 py-3 text-sm bg-white border-[1.5px] rounded-md text-secondary placeholder:hidden focus:outline-none focus:ring-0 peer
          ${
            error
              ? "border-[#E00000] focus:border-[#E00000]"
              : "border-[#6B737A] focus:border-primary"
          }
          ${isPasswordField ? "pr-12" : ""}`}
        onPaste={handlePaste}
        onBlur={handleBlur}
        onChange={onChange} // Ensures value updates are handled
        aria-invalid={!!error} // Accessibility improvement
        aria-describedby={error ? `${id}-error` : undefined}
      />
      <label
        htmlFor={id}
        className={`absolute cursor-text text-sm duration-200 transform scale-75 -translate-y-4 top-1.5 left-3 bg-white px-1 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2
          peer-focus:scale-75 peer-focus:top-1.5 peer-focus:-translate-y-4
          ${
            error
              ? "text-[#E00000] peer-focus:text-[#E00000]"
              : "text-gray-500 peer-focus:text-primary"
          }`}
      >
        {placeholder}
      </label>

      {isPasswordField && (
        <img
          src={`/assets/eye${showPassword ? "" : "-close"}.svg`}
          alt={showPassword ? "Hide password" : "Show password"} // Improved alt text
          className="h-5 cursor-pointer absolute right-4 top-1/2 transform -translate-y-1/2"
          onClick={togglePasswordVisibility}
        />
      )}

      {error && (
        <p
          id={`${id}-error`}
          className="absolute mt-1 text-left text-xs text-[#E00000]"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default FloatingInput;
